export default __webpack_public_path__ + "static/metaimage-b8e7129057919beda80798e82aa941df.png";